import { Routes } from '@angular/router';
import { checkInfoGuard } from './_core/_guards/check-info.guard';
import { Empty } from './_core/_shared/_components/empty/empty';
import { featureGuard } from './_core/_guards/feature.guard';

export const routes: Routes = [
  {
    path: 'info',
    canActivate: [checkInfoGuard],
    loadComponent: () =>
      import('./info/info.component').then((c) => c.InfoComponent),
    loadChildren: () => import('./info/info.routes').then((c) => c.routes),
  },
  {
    path: 'test',
    children: [
      {
        path: 'feature-access',
        loadComponent: () =>
          import('./_core/_theme/test/feature-access/feature-access-test.component').then(
            (c) => c.FeatureAccessTestComponent,
          ),
      },
      {
        path: 'feature-access/protected',
        canActivate: [featureGuard],
        data: {
          feature: 'geomarketing',
        },
        loadComponent: () =>
          import('./_core/_theme/test/feature-access/feature-access-protected.component').then(
            (c) => c.FeatureAccessProtectedComponent,
          ),
      },
      {
        path: 'tema',
        loadComponent: () =>
          import('./_core/_theme/test/test.component').then(
            (c) => c.TestComponent,
          ),
      },
      {
        path: 'translate',
        loadComponent: () =>
          import('./_core/_translate/test/test.component').then(
            (c) => c.TestComponent,
          ),
      },
      {
        path: 'formly',
        loadComponent: () =>
          import('./_core/_formly/test/test.component').then(
            (c) => c.TestComponent,
          ),
      },
    ],
  },
  {
    path: 'login/social/callback',
    loadComponent: () =>
      import('./public/login/social-callback/social-callback.component').then(
        (c) => c.SocialCallbackComponent,
      ),
  },
  { path: '__logout', component: Empty },
  {
    path: '',
    loadComponent: () =>
      import('./public/public.component').then((c) => c.PublicComponent),
    loadChildren: () => import('./public/public.routes').then((c) => c.routes),
  },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  {
    path: '**',
    loadComponent: () =>
      import('./page-not-found/page-not-found.component').then(
        (c) => c.PageNotFoundComponent,
      ),
  },
];
